var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03033 2.21967C7.73744 1.92678 7.26256 1.92678 6.96967 2.21967L3.59467 5.59467C3.30178 5.88756 3.30178 6.36244 3.59467 6.65533C3.88756 6.94822 4.36244 6.94822 4.65533 6.65533L7.5 3.81066L10.3447 6.65533C10.6376 6.94822 11.1124 6.94822 11.4053 6.65533C11.6982 6.36244 11.6982 5.88756 11.4053 5.59467L8.03033 2.21967ZM4.65533 9.34467C4.36244 9.05178 3.88756 9.05178 3.59467 9.34467C3.30178 9.63756 3.30178 10.1124 3.59467 10.4053L6.96967 13.7803C7.26256 14.0732 7.73744 14.0732 8.03033 13.7803L11.4053 10.4053C11.6982 10.1124 11.6982 9.63756 11.4053 9.34467C11.1124 9.05178 10.6376 9.05178 10.3447 9.34467L7.5 12.1893L4.65533 9.34467Z",
    fill: "#1495CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdown);
export default __webpack_public_path__ + "static/media/icon-dropdown.9199c73be51bae5892701059bfab0df3.svg";
export { ForwardRef as ReactComponent };